import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { HttpStatusCode } from 'axios';
import globalProgramStore from '../../../../../stores/program-store';

export const deleteStudentFromProgram = async (
  branchId: number | undefined,
  programId: number | undefined,
  yearNumber: number | undefined,
  studentId: number | undefined,
  setLoading: (paymentServiceId: number | null) => any,
) => {
  try {
    if (!branchId || !programId || !studentId || yearNumber === undefined) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }

    setLoading(studentId);

    const res = await appApi.deleteStudentFromProgram(
      branchId,
      programId,
      yearNumber,
      studentId,
    );
    if (res.status === HttpStatusCode.Ok) {
      globalProgramStore.updateProgramDetails(programId, res.data.body);
    }
    setLoading(null);
  } catch (e) {
    setLoading(null);
    toast.error(
      'לא ניתן להוריד סטודנט המשוויך לקורס בתוכנית ו/או ששילם עבור שרות בתוכנית',
    );
  }
};
